// extracted by mini-css-extract-plugin
module.exports = {"main":"index_main__Wf8X4","tagGreen":"index_tagGreen__MOb3O","tagRed":"index_tagRed__CBW48"};